import { useRouter } from 'next/router'
import { AMENITIES } from '../SearchForm/constants'
import useSEMSearchCheapKeywordExperiment from './useSEMSearchCheapKeywordExperiment'

export default function useSEMSearchHeadline() {
  const { query } = useRouter()
  const { SEMSearch, SEMSEARCH } = query
  const semSearchParam = (
    (SEMSearch || SEMSEARCH) as string | undefined
  )?.toUpperCase() as keyof typeof AMENITIES
  let amenityHeadline: string | null =
    useSEMSearchCheapKeywordExperiment(semSearchParam)
  if (!amenityHeadline && semSearchParam !== 'CHEAP') {
    amenityHeadline = AMENITIES[semSearchParam]
  }
  return amenityHeadline ?? null
}
